import './Checkbox.scss';
import * as React from 'react';
import classNames from 'classnames';
export type Props = {
  checked: boolean;
  disabled: boolean;
  onChange?: (a: SyntheticInputEvent<HTMLInputElement>) => void;
  children: React.ReactNode | undefined | null;
  name?: string;
  value?: string;
  type: 'checkbox' | 'radio';
  className?: string;
  inputClassName?: string;
  onLight: boolean;
  tabIndex?: number;
};
export default class Checkbox extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    onLight: false,
    type: 'checkbox',
  };
  render() {
    const {
      checked,
      disabled,
      onChange,
      children,
      name,
      value,
      type,
      className,
      inputClassName,
      onLight,
    } = this.props;
    return (
      <label
        className={classNames('Checkbox', className, {
          onLight,
        })}
      >
        <input
          type={type}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          name={name}
          value={value}
          className={classNames(
            `Checkbox-input Checkbox-input--${type}`,
            inputClassName,
          )}
        />

        {children != null && (
          <span className="Checkbox-labelText">{children}</span>
        )}
      </label>
    );
  }
}
